import { useState } from "react"
import { useSelector } from "react-redux"
import { InformationCircleIcon, MagnifyingGlassIcon, PlusCircleIcon, PencilIcon } from "@heroicons/react/24/outline"
import { UserIcon, ChevronRightIcon, ClipboardDocumentListIcon } from '@heroicons/react/20/solid'
import { GetPrimaryColorHex } from "redux/slices/brand"
import StrengthIcon from 'media/icons/strength.png'
import MobilityIcon from 'media/icons/mobility.png'
import moment from "moment"

import ScreenFrame from 'components/Frame/ScreenFrame'

import BrandColorButton from "components/Buttons/BrandColorButton"
import OutlineButton from "components/Buttons/OutlineButton"
import SolidButton from "components/Buttons/SolidButton"

export default function UIDesignSpecView() {

    const tabs = [
        'Option 1',
        'Option 2',
        'Option 3',
        'Option 4',
        'Option 5',
        'Option 6'
    ]

    const athletes = [
        {
            'firstName': 'John',
            'lastName': 'Smith',
            'email': 'john.smith@example.com',
            'coachFirstName': 'Chris',
            'coachLastName': 'Lee',
            'coachEmail': 'chris@kinesisintegrated.com'
        },
        {
            'firstName': 'Jacob',
            'lastName': 'Carlson',
            'email': 'imjncarlson@gmail.com',
            'coachFirstName': 'Chris',
            'coachLastName': 'Lee',
            'coachEmail': 'chris@kinesisintegrated.com'
        }
    ]

    const coaches = [
        {
            'firstName': 'Chris',
            'lastName': 'Lee',
            'email': 'chris@kinesisintegrated.com',
            'role': 'Organization Admin'
        },
        {
            'firstName': 'Collen',
            'lastName': 'Mclain',
            'email': 'collen@kinesisintegrated.com',
            'role': 'Coach'
        }
    ]

    const completedAssessments = [
        {
            'workoutName': 'Run Assessment',
            'athlete': 'John Smith',
            'score': 85,
            'date': '2025-07-04'
        },
        {
            'workoutName': 'Tri Assessment',
            'athlete': 'Jacob Carlson',
            'score': 95,
            'date': '2025-06-10'
        },
        {
            'workoutName': 'Cycling Assessment',
            'athlete': 'John Smith',
            'score': 15,
            'date': '2025-02-23'
        }
    ]

    const completedWorkouts = [
        {
            'workoutName': 'Strength Session A',
            'workoutIcon': StrengthIcon,
            'athlete': 'John Smith',
            'date': '2025-07-04'
        },
        {
            'workoutName': 'Strength Session B',
            'workoutIcon': StrengthIcon,
            'athlete': 'Jacob Carlson',
            'date': '2025-06-10'
        },
        {
            'workoutName': 'Mobility A',
            'workoutIcon': MobilityIcon,
            'athlete': 'John Smith',
            'date': '2025-02-23'
        }
    ]

    const kinesisEvents = [
        // {
        //     "id": 747,
        //     "traineeId": 297,
        //     "name": "The B Race",
        //     "eventType": "b-race",
        //     "eventDate": "2025-07-31",
        //     "createdDate": "2025-05-28 20:21:59.09",
        //     "archived": 0,
        //     "eventTrainingStartDate": "2025-07-31",
        //     "deloadAfterEvent": 0,
        //     "programEndDate": null,
        //     "eventDistance": "sport-distance",
        //     "eventDistanceTextInput": "",
        //     "eventTerrain": "xterra",
        //     "eventTerrainTextInput": ""
        // },
        // {
        //     "id": 759,
        //     "traineeId": 297,
        //     "name": "CRACE",
        //     "eventType": "c-race",
        //     "eventDate": "2025-08-07",
        //     "createdDate": "2025-06-03 21:39:59.19",
        //     "archived": 0,
        //     "eventTrainingStartDate": "2025-08-07",
        //     "deloadAfterEvent": 0,
        //     "programEndDate": null,
        //     "eventDistance": "5k",
        //     "eventDistanceTextInput": "",
        //     "eventTerrain": "road-track",
        //     "eventTerrainTextInput": ""
        // },
        // {
        //     "id": 740,
        //     "traineeId": 297,
        //     "name": "My Newest A Race",
        //     "eventType": "a-race",
        //     "eventDate": "2025-08-16",
        //     "createdDate": "2025-05-25 17:15:34.42",
        //     "archived": 0,
        //     "eventTrainingStartDate": "2025-05-19",
        //     "deloadAfterEvent": 1,
        //     "programEndDate": "2025-09-13",
        //     "eventDistance": "short-course",
        //     "eventDistanceTextInput": "",
        //     "eventTerrain": "xterra",
        //     "eventTerrainTextInput": ""
        // },
        // {
        //     "id": 762,
        //     "traineeId": 297,
        //     "name": "Brace2",
        //     "eventType": "b-race",
        //     "eventDate": "2025-09-17",
        //     "createdDate": "2025-06-16 01:51:20.61",
        //     "archived": 0,
        //     "eventTrainingStartDate": "2025-09-17",
        //     "deloadAfterEvent": 0,
        //     "programEndDate": null,
        //     "eventDistance": "40k",
        //     "eventDistanceTextInput": "",
        //     "eventTerrain": "trail",
        //     "eventTerrainTextInput": ""
        // },
        {
            "id": 871,
            "traineeId": 297,
            "name": "Another C Race",
            "eventType": "c-race",
            "eventDate": "2025-10-30",
            "createdDate": "2025-10-22 18:40:58.78",
            "archived": 0,
            "eventTrainingStartDate": "2025-10-30",
            "deloadAfterEvent": 0,
            "programEndDate": null,
            "eventDistance": "5k",
            "eventDistanceTextInput": "",
            "eventTerrain": "road-track",
            "eventTerrainTextInput": ""
        },
        {
            "id": 887,
            "traineeId": 297,
            "name": "St Pattys 2026",
            "eventType": "b-race",
            "eventDate": "2026-03-17",
            "createdDate": "2025-11-18 19:27:55.73",
            "archived": 0,
            "eventTrainingStartDate": "2026-03-17",
            "deloadAfterEvent": 0,
            "programEndDate": null,
            "eventDistance": "10k",
            "eventDistanceTextInput": "",
            "eventTerrain": "trail",
            "eventTerrainTextInput": ""
        },
        {
            "id": 828,
            "traineeId": 297,
            "name": "Default Event",
            "eventType": "a-race",
            "eventDate": "2026-08-31",
            "createdDate": "2025-09-15 17:19:25.14",
            "archived": 0,
            "eventTrainingStartDate": "2025-11-10",
            "deloadAfterEvent": 1,
            "programEndDate": "2026-09-28",
            "eventDistance": "other",
            "eventDistanceTextInput": "default-event",
            "eventTerrain": "other",
            "eventTerrainTextInput": "default-event"
        }
    ]

    const activeInjuries = [
        {
            'athleteName': 'John Smith',
            'injuryType': 'Patellar Tendon',
            'duration': '4 days'
        },
        {
            'athleteName': 'John Smith',
            'injuryType': 'Achilles Tendon',
            'duration': '2 weeks'
        },
        {
            'athleteName': 'Jacob Carlson',
            'injuryType': 'Bone Stress',
            'duration': '10 weeks'
        }
    ]

    const styleConfig = useSelector((state) => state.brand.styleConfig)

    const [textInputValue, setTextInputValue] = useState('')
    const [labelledTextInputValue, setLabelledTextInputValue] = useState('')
    const [dropdownValue, setDropdownValue] = useState('')
    const [searchTerm, setSearchTerm] = useState('')
    const [searchTermWithButton, setSearchTermWithButton] = useState('')
    const [searchTermWithDropdown, setSearchTermWithDropdown] = useState('')
    const [searchTermDropdown, setSearchTermDropdown] = useState('')
    const [selectedTab, setSelectedTab] = useState(tabs[0])

    return (
        <ScreenFrame>
            <div className="h-full overflow-y-auto">
                <div className="mx-auto max-w-7xl py-12 px-4 space-y-12">

                    <h1 className='underline text-4xl'>Text: Plus Jakarta Sans Font</h1>

                    <div className="space-y-4">
                        <h1>Title Text (Bold - 20px)</h1>
                        <h2>Sub Heading Text (Medium - 16px)</h2>
                        <p>Body Text (Normal - 16px) </p>
                        <p>ABCDEFGHIJKLMNOPQRSTUVWXYZ. abcdefghijklmnopqrstuvwxyz. 1234567890. ~!@#$%^&*()_+</p>
                        <p className="text-sm text-gray-500">Fine Print Text</p>
                    </div>

                    <h1 className='underline text-4xl'>Containers</h1>

                    <div className="grid grid-cols-3 gap-x-4">
                        <div className="space-y-4">
                            <div className="pl-4">Container</div>

                            <div className="w-full h-[500px] flex flex-col items-center justify-center bg-white border border-gray-300 shadow-md rounded-2xl overflow-hidden">
                                <p className="text-sm text-gray-500">Add Content Here</p>
                            </div>
                        </div>

                        <div className="space-y-4">
                            <div className="pl-4">Container with Title</div>

                            <div className="w-full h-[500px] items-center justify-center bg-white border border-gray-300 shadow-md rounded-2xl overflow-hidden">
                                <div className="py-2 border-b border-gray-300 cursor-pointer flex items-center justify-center gap-x-2">
                                    <p className="text-center">Add Container Title Here</p>
                                    <InformationCircleIcon className="mt-0.5 w-5 h-5 text-gray-600" />
                                </div>

                                <div className="h-full w-full flex flex-col items-center justify-center">
                                    <p className="text-sm text-gray-500 pb-20">Add Content Here</p>
                                </div>
                            </div>
                        </div>

                        <div className="space-y-4">
                            <div className="pl-4">Container with Title and Bottom Section</div>

                            <div className="w-full h-[500px] items-center justify-center bg-white border border-gray-300 shadow-md rounded-2xl overflow-hidden">
                                <div className="py-2 border-b border-gray-300 cursor-pointer flex items-center justify-center gap-x-2">
                                    <p className="text-center">Add Container Title Here</p>
                                    <InformationCircleIcon className="mt-0.5 w-5 h-5 text-gray-600" />
                                </div>

                                <div className="h-full w-full flex flex-col items-center justify-center">

                                    <div className="w-full h-[180px]" />

                                    <p className="my-auto text-sm text-gray-500 pb-20">Add Content Here</p>

                                    <div className="w-full h-[180px] bg-gray-50 border-t border-gray-300" />

                                </div>
                            </div>
                        </div>
                    </div>

                    <h1 className='underline text-4xl'>Buttons</h1>
                    
                    <p className="font-bold underline">Colored Buttons</p>
                    
                    <div className="flex items-start gap-x-4">
                        <div className="w-60 space-y-4">
                            <div>Large</div>
                            <BrandColorButton size="large" text="Button Text" />
                            <BrandColorButton size="large" text="Brand Color Button" isLoading={true} />
                        </div>

                        <div className="w-40 space-y-4">
                            <div className="text-sm">Small</div>
                            <BrandColorButton text="Button Text" />
                            <BrandColorButton text="Brand Color Button" isLoading={true} />
                        </div>

                        <div className="w-32 space-y-4">
                            <div className="text-sm">Extra Small</div>
                            <BrandColorButton size="extra-small" text="Button Text" />
                            <BrandColorButton size="extra-small" text="Brand Color Button" isLoading={true} />
                        </div>
                    </div>

                    <p className="font-bold underline">Outline Buttons</p>

                    <div className="flex items-start gap-x-4">
                        <div className="w-60 space-y-4">
                            <div>Large</div>
                            <OutlineButton size="large" text="Button Text" />
                            <OutlineButton size="large" text="Brand Color Button" isLoading={true} />
                        </div>

                        <div className="w-40 space-y-4">
                            <div className="text-sm">Small</div>
                            <OutlineButton text="Button Text" />
                            <OutlineButton text="Brand Color Button" isLoading={true} />
                        </div>

                        <div className="w-32 space-y-4">
                            <div className="text-sm">Extra Small</div>
                            <OutlineButton size="extra-small" text="Button Text" />
                            <OutlineButton size="extra-small" text="Brand Color Button" isLoading={true} />
                        </div>
                    </div>

                    <h1 className='underline text-4xl'>Inputs</h1>

                    <div className="space-y-4">

                        <div>Text Input Box</div>

                        <input
                            type="text"
                            className="w-1/2 py-2 px-3 rounded-md border border-gray-300 bg-white placeholder-gray-500 focus:border-orange-400 focus:outline-none focus:ring-1 focus:ring-orange-400"
                            placeholder="Enter Text Here"
                            value={textInputValue}
                            onChange={(event) => setTextInputValue(event.target.value)}
                        />

                        <div>Text Input Box with label</div>

                        <div className="space-y-1">
                            <div className="pl-2 text-sm text-gray-600">Add Label Here</div>

                            <input
                                type="text"
                                className="w-1/2 py-2 px-3 rounded-md border border-gray-300 bg-white placeholder-gray-500 focus:border-orange-400 focus:outline-none focus:ring-1 focus:ring-orange-400"
                                placeholder="Enter Text Here"
                                value={labelledTextInputValue}
                                onChange={(event) => setLabelledTextInputValue(event.target.value)}
                            />
                        </div>

                        <div>Dropdown Input</div>

                        <div className="w-1/2">
                            <div className="border border-gray-300 rounded-md">
                                <select
                                    className="w-full py-2 px-3 rounded-md bg-white border-r-[10px] border-white cursor-pointer focus:outline-none focus:ring-2 focus:ring-orange-400"
                                    value={dropdownValue}
                                    onChange={(e) => setDropdownValue(e.target.value)}
                                >
                                    <option value="">Select an Option</option>
                                    <option value="option1">Option 1</option>
                                    <option value="option2">Option 2</option>
                                    <option value="option3">Option 3</option>
                                    <option value="option4">Option 4</option>
                                    <option value="option5">Option 5</option>
                                    <option value="option6">Option 6</option>
                                </select>
                            </div>
                        </div>

                        <div>Search Input Box</div>

                        <div className="w-1/2 relative">
                            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                                <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                            </div>

                            <input
                                type="text"
                                className="w-full py-2 pl-10 pr-3 rounded-md border border-gray-300 bg-white placeholder-gray-500 focus:border-orange-400 focus:outline-none focus:ring-1 focus:ring-orange-400"
                                placeholder="Enter Search Term Here"
                                value={searchTerm}
                                onChange={(event) => setSearchTerm(event.target.value)}
                            />
                        </div>

                        <div>Search Input Box With Button</div>

                        <div className="flex gap-x-4">
                            <div className="flex-grow relative">
                                <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                                    <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                </div>

                                <input
                                    type="text"
                                    className="w-full py-2 pl-10 pr-3 rounded-md border border-gray-300 bg-white placeholder-gray-500 focus:border-orange-400 focus:outline-none focus:ring-1 focus:ring-orange-400"
                                    placeholder="Enter Athlete Name or Email"
                                    value={searchTermWithButton}
                                    onChange={(event) => setSearchTermWithButton(event.target.value)}
                                />
                            </div>

                            <div className="w-40">
                                <BrandColorButton text="Add Athlete" />
                            </div>
                        </div>

                        <div>Search Input Box With Dropdown</div>

                        <div className="flex gap-x-4">
                            <div className="flex-grow relative">
                                <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                                    <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                </div>

                                <input
                                    type="text"
                                    className="w-full py-2 pl-10 pr-3 rounded-md border border-gray-300 bg-white placeholder-gray-500 focus:border-orange-400 focus:outline-none focus:ring-1 focus:ring-orange-400"
                                    placeholder="Enter Athlete Name or Email"
                                    value={searchTermWithDropdown}
                                    onChange={(event) => setSearchTermWithDropdown(event.target.value)}
                                />
                            </div>

                            <div className="w-40">
                                <div className="border border-gray-300 rounded-md">
                                    <select
                                        className="w-full py-2 px-3 rounded-md bg-white border-r-[10px] border-white cursor-pointer focus:outline-none focus:ring-2 focus:ring-orange-400"
                                        value={searchTermDropdown}
                                        onChange={(e) => setSearchTermDropdown(e.target.value)}
                                    >
                                        <option value="">Filter</option>
                                        <option value="option1">Option 1</option>
                                        <option value="option2">Option 2</option>
                                        <option value="option3">Option 3</option>
                                        <option value="option4">Option 4</option>
                                        <option value="option5">Option 5</option>
                                        <option value="option6">Option 6</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="pt-4">Tab Group</div>

                        <div className="w-3/4 grid grid-cols-6">
                            {tabs.map((tab, index) => (
                                <button
                                    key={index}
                                    className={`
                                        border-b-[3px] pt-4 pb-3 text-center cursor-pointer
                                        ${tab === selectedTab ? 'font-bold' : ''}
                                        ${tab !== selectedTab ? 'font-medium border-gray-300 text-gray-500 hover:text-gray-700' : ''}
                                    `}
                                    style={{
                                        borderColor: tab === selectedTab ? GetPrimaryColorHex(styleConfig) : '',
                                        color: tab === selectedTab ? GetPrimaryColorHex(styleConfig) : '',
                                    }}
                                    onClick={() => setSelectedTab(tab)}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>

                    </div>
                    
                    {/*                     
                    <h1 className='underline text-4xl'>List Items</h1>

                    <div>Athlete Profile List Items</div>

                    <div className="w-full flex flex-col bg-white border border-gray-300 divide-y divide-gray-300 rounded-2xl overflow-hidden">
                        {athletes.map((athlete, index) => (
                            <li 
                                key={index}
                                className="flex items-center px-6 py-4 gap-x-6 hover:bg-gray-50 cursor-pointer"
                            >
                                <div className="h-12 w-12 bg-gray-100 rounded-full items-center">
                                    <UserIcon className="h-8 text-gray-400 m-2" />
                                </div>

                                <div className="flex-grow">
                                    <p className="font-lg font-semibold">{athlete.firstName} {athlete.lastName}</p>
                                    <p className="text-sm">{athlete.email}</p>
                                </div>
    
                                <div 
                                    className="flex items-center gap-x-4"
                                    onMouseEnter={(e) => e.stopPropagation()}
                                >
                                    <div>Coach:</div>

                                    <div className="border border-gray-300 rounded-md">
                                        <select
                                            className="w-52 py-2 px-3 rounded-md bg-white border-r-[10px] border-white cursor-pointer focus:outline-none focus:ring-2 focus:ring-orange-400"
                                            value={dropdownValue}
                                            // onChange={(e) => setDropdownValue(e.target.value)}
                                        >
                                            <option value="">{athlete.coachFirstName} {athlete.coachLastName}</option>
                                            <option value="option1">Option 1</option>
                                            <option value="option2">Option 2</option>
                                            <option value="option3">Option 3</option>
                                            <option value="option4">Option 4</option>
                                            <option value="option5">Option 5</option>
                                            <option value="option6">Option 6</option>
                                        </select>
                                    </div>
                                </div>
                                
                                <ChevronRightIcon className="text-gray-400 h-8" />
                            </li>
                        ))}
                    </div>

                    <div>Coach Profile List Items</div>

                    <div className="w-full flex flex-col bg-white border border-gray-300 divide-y divide-gray-300 rounded-2xl overflow-hidden">
                        {coaches.map((coach, index) => (
                            <li 
                                key={index}
                                className="flex items-center px-6 py-4 gap-x-6 hover:bg-gray-50 cursor-pointer"
                            >
                                <div className="h-12 w-12 bg-gray-100 rounded-full items-center">
                                    <UserIcon className="h-8 text-gray-400 m-2" />
                                </div>

                                <div className="flex-grow">
                                    <p className="font-lg font-semibold">{coach.firstName} {coach.lastName}</p>
                                    <p className="text-sm">{coach.email}</p>
                                </div>
    
                                <div 
                                    className="flex items-center gap-x-4"
                                    onMouseEnter={(e) => e.stopPropagation()}
                                >
                                    <div>Role:</div>

                                    <div className="border border-gray-300 rounded-md">
                                        <select
                                            className="w-52 py-2 px-3 rounded-md bg-white border-r-[10px] border-white cursor-pointer focus:outline-none focus:ring-2 focus:ring-orange-400"
                                            value={dropdownValue}
                                            // onChange={(e) => setDropdownValue(e.target.value)}
                                        >
                                            <option value="">{coach.role}</option>
                                            <option value="option1">Option 1</option>
                                            <option value="option2">Option 2</option>
                                            <option value="option3">Option 3</option>
                                            <option value="option4">Option 4</option>
                                            <option value="option5">Option 5</option>
                                            <option value="option6">Option 6</option>
                                        </select>
                                    </div>
                                </div>
                                
                                <ChevronRightIcon className="text-gray-400 h-8" />
                            </li>
                        ))}
                    </div>

                    <div>Completed Assessment List Items</div>

                    <div className="w-full border border-gray-300 divide-y divide-gray-300 rounded-2xl overflow-hidden">
                        {completedAssessments.map((assessment, index) => (
                            <li 
                                key={index}
                                className="flex items-center px-6 py-4 gap-x-6 hover:bg-gray-50 cursor-pointer"
                            >
                                <div className="h-12 w-12 bg-gray-100 rounded-full items-center">
                                    <ClipboardDocumentListIcon className="h-6 m-3 opacity-50" />
                                </div>

                                <div className="flex-grow">
                                    <p className="font-lg font-semibold">{assessment.workoutName}</p>
                                    <p className="text-sm">{assessment.athlete}</p>
                                </div>

                                <div className="flex items-center gap-x-4 pr-4">
                                    <p className="w-24 text-left text-sm">Score: {assessment.score}%</p>

                                    <div className="w-52 h-3 bg-gray-200 rounded-full overflow-hidden">
                                        <div 
                                            className="h-full bg-orange-400 rounded-full"
                                            style={{ width: `${assessment.score}%` }}
                                        />
                                    </div>

                                </div>
    
                                <p className="w-64 text-left text-sm">{moment(assessment.date).format('hh:mma MMMM D, YYYY')}</p>
                                
                                <ChevronRightIcon className="text-gray-400 h-8" />
                            </li>
                        ))}
                    </div>

                    <div>Completed Workout List Items</div>

                    <div className="w-full border border-gray-300 rounded-2xl overflow-hidden">
                        <div className="h-full w-full flex flex-col divide-y divide-gray-300">
                            {completedWorkouts.map((completedWorkout, index) => (
                                <li 
                                    key={index}
                                    className="flex items-center px-6 py-4 gap-x-6 hover:bg-gray-50 cursor-pointer"
                                >
                                    <div className="h-12 w-12 bg-gray-100 rounded-full items-center">
                                        <img src={completedWorkout.workoutIcon} alt="Workout Icon" className="h-6 m-3 opacity-60" />
                                    </div>

                                    <div className="flex-grow">
                                        <p className="font-lg font-semibold">{completedWorkout.workoutName}</p>
                                        <p className="text-sm">{completedWorkout.athlete}</p>
                                    </div>
        
                                    <p className="w-64 text-left text-sm">{moment(completedWorkout.date).format('hh:mma MMMM D, YYYY')}</p>
                                    
                                    <ChevronRightIcon className="text-gray-400 h-8" />
                                </li>
                            ))}
                        </div>
                    </div>

                    <div>Event List Items</div>

                    <div className="w-1/3">
                        <div className="w-full h-[500px] items-center justify-center bg-white border border-gray-300 rounded-2xl overflow-hidden">
                            <div className="py-2 border-b border-gray-300 cursor-pointer flex items-center justify-center gap-x-2">
                                <p className="text-center">Races and Events</p>
                                <PlusCircleIcon className="mt-0.5 w-5 h-5 text-gray-600" />
                            </div>

                            <div className="h-full w-full flex flex-col">
                                {kinesisEvents.map((kinesisEvent) => (
                                    <div className='flex items-center gap-x-2 pr-4 relative bg-white border-b border-gray-300 overflow-hidden transition-all'>
            
                                        <div>
                                            <div className='ml-4 mr-2 w-8 h-8 bg bg-gray-100 rounded-full flex items-center justify-center font-semibold text-lg text-gray-500'>
                                                {kinesisEvent.eventType === 'a-race' ? 'A' : ''}
                                                {kinesisEvent.eventType === 'b-race' ? 'B' : ''}
                                                {kinesisEvent.eventType === 'c-race' ? 'C' : ''}
                                            </div>
                                        </div>
                                        
                                        <div className='py-4 flex-grow'>
                                            <div className='text-sm font-semibold'>
                                                {kinesisEvent.name}
                                            </div>
                            
                                            <div className='text-xs text-gray-500'>
                                                {kinesisEvent.eventTerrain && 
                                                    <>
                                                        {kinesisEvent.eventTerrain === 'other' &&
                                                            <>
                                                                {kinesisEvent.eventTerrainTextInput === 'default-event' ? 'Other' : kinesisEvent.eventTerrainTextInput}
                                                            </>
                                                        }
                            
                                                        {kinesisEvent.eventTerrain !== 'other' &&
                                                            <>
                                                                {kinesisEvent.eventTerrain.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                                                            </>
                                                        }
                                                    </>
                                                } 
                                                
                                                {' '}
                            
                                                {kinesisEvent.eventDistance &&
                                                    <>
                                                        {kinesisEvent.eventDistance === 'other' && kinesisEvent.eventDistanceTextInput !== 'default-event' &&
                                                            <>
                                                                {kinesisEvent.eventDistanceTextInput}
                                                            </>
                                                        }
                            
                                                        {kinesisEvent.eventDistance !== 'other' &&
                                                            <>
                                                                {kinesisEvent.eventDistance.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                                                            </>
                                                        }
                                                    </>
                                                }
                                            </div>
                                        </div>
                            
                                        <div className='flex flex-col items-center justify-center pt-2 gap-y-0.5 relative'>
                                            <svg width="40" height="24" viewBox="0 0 40 24" className="block rounded-sm border-l border-b border-gray-400 scale-x-90" xmlns="http://www.w3.org/2000/svg">
                                                <polygon points="0,0 0,24 40,24" fill="white" />
                                                <line x1="0" y1="0" x2="40" y2="24" stroke="#9ca3af" strokeWidth="1" />
                                            </svg>
                            
                                            <div className='absolute bottom-4 left-1.5'>
                                                <div className='text-xs'>
                                                    {kinesisEvent.eventType === 'a-race' ? '3' : ''}
                                                    {kinesisEvent.eventType === 'b-race' ? '2' : ''}
                                                    {kinesisEvent.eventType === 'c-race' ? '1' : ''}
                                                </div>
                                            </div>
                            
                                            <div className='text-[8px]'>Taper</div>
                                        </div>
                            
                                        <div>
                                            <div 
                                                className='scale-[0.9] h-10 w-10 border border-gray-400 rounded-md bg-white hover:bg-gray-50 cursor-pointer'
                                                // onClick={() => NavigateCalendarToEvent()}
                                            >
                                                <div className='text-center text-xxs border-b border-gray-400'>
                                                    {moment(kinesisEvent.eventDate).format('MMM')}
                                                </div>
                            
                                                <div className='pt-[1px] text-center text-sm'>
                                                    {moment(kinesisEvent.eventDate).format('D')}
                                                </div>
                                            </div>
                                        </div>
                            
                                        <div>
                                            <div 
                                                className='scale-[0.9] h-10 w-10 flex items-center justify-center border border-gray-400 rounded-md bg-white hover:bg-gray-50 cursor-pointer'
                                                // onClick={() => OpenEventManagementModal()}
                                            >
                                                <PencilIcon className='h-6 w-6 text-gray-500' />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div>Active Injury List Items</div>

                    <div className="w-1/4 border border-gray-300 divide-y divide-gray-300 rounded-2xl overflow-hidden">
                        {activeInjuries.map((injury, index) => (
                            <div 
                                key={index} 
                                className="flex items-center px-4 py-2 gap-x-4 cursor-pointer hover:bg-gray-50"
                            >
                                <div className="flex-grow">
                                    <p className="text-sm">{injury.injuryType}</p>
                                    <p className="text-xs text-gray-600">{injury.athleteName}</p>
                                </div>

                                <div className="bg-orange-400 rounded-full py-1 w-20">
                                    <p className="text-center text-xs font-bold text-white">{injury.duration}</p>
                                </div>
                            </div>
                        ))}
                    </div> 
                    */}

                </div>
            </div>
        </ScreenFrame>
    )
}